/**
 * ConfirmModal - Modale conferma con tema Dialogicom
 */
import React from 'react';
import { AlertCircle, Trash2, X } from 'lucide-react';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'info';
  /** Se true, nasconde il bottone Annulla (modale solo-OK) */
  hideCancel?: boolean;
  children?: React.ReactNode;
  /** Offset verticale in px rispetto al centro (negativo = più in alto) */
  offsetY?: number;
  /** Se true, ancora la modale in alto (sotto la navbar) invece di centrare verticalmente */
  anchorTop?: boolean;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Conferma',
  cancelText = 'Annulla',
  variant = 'warning',
  hideCancel = false,
  children,
  offsetY = 0,
  anchorTop = false
}) => {
  if (!isOpen) return null;

  const handleConfirm = async () => {
    console.log('🔴🔴🔴 [ConfirmModal] handleConfirm CLICK! 🔴🔴🔴');
    console.log('🔴 [ConfirmModal] onConfirm type:', typeof onConfirm);
    console.log('🔴 [ConfirmModal] onConfirm function:', onConfirm);
    try {
      console.log('🔴 [ConfirmModal] Chiamando onConfirm()...');
      await onConfirm();
      console.log('🔴 [ConfirmModal] onConfirm() completato!');
    } catch (error) {
      console.error('🔴 [ConfirmModal] ERRORE in onConfirm:', error);
    }
    // NON chiamare onClose - il redirect dovrebbe già essere avvenuto
    // onClose();
  };

  const variantStyles = {
    danger: {
      bg: 'from-red-600 to-red-700',
      icon: <Trash2 className="w-8 h-8 text-red-400" />,
      border: 'border-red-500'
    },
    warning: {
      bg: 'from-yellow-600 to-orange-600',
      icon: <AlertCircle className="w-8 h-8 text-yellow-400" />,
      border: 'border-yellow-500'
    },
    info: {
      bg: 'from-blue-600 to-blue-700',
      icon: <AlertCircle className="w-8 h-8 text-blue-400" />,
      border: 'border-blue-500'
    }
  };

  const style = variantStyles[variant];

  return (
    <div className={`fixed inset-0 z-[999999] flex ${anchorTop ? 'items-start pt-20' : 'items-center'} justify-center p-4 bg-black/70 backdrop-blur-sm`}>
      <div
        className="bg-gray-900 rounded-xl shadow-2xl border border-gray-700 max-w-md w-full"
        style={offsetY && !anchorTop ? { transform: `translateY(${offsetY}px)` } : undefined}
      >
        {/* Header */}
        <div className={`bg-gradient-to-br ${style.bg} p-4 rounded-t-xl flex items-center justify-between`}>
          <div className="flex items-center gap-3">
            {style.icon}
            <h3 className="text-white font-semibold text-lg">{title}</h3>
          </div>
          <button
            onClick={onClose}
            className="text-white/80 hover:text-white transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-gray-300 text-base leading-relaxed whitespace-pre-line">{message}</p>
          {children}
        </div>

        {/* Footer */}
        <div className="p-4 bg-gray-800/50 rounded-b-xl flex gap-3 justify-end">
          {!hideCancel && (
            <button
              onClick={onClose}
              className="px-6 py-2.5 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors font-medium"
            >
              {cancelText}
            </button>
          )}
          <button
            onClick={handleConfirm}
            className={`px-6 py-2.5 bg-gradient-to-br ${style.bg} hover:opacity-90 text-white rounded-lg transition-opacity font-medium border ${style.border}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};
